{
  "action": {
    "label": "Action"
  },
  "actionType": {
    "label": "Action type",
    "value": {
      "alert": "Alert",
      "dvtm": "DVTM",
      "external_platform": "External platform",
      "group": "Group",
      "iam": "IAM",
      "platform": "Platform",
      "profile": "Profile",
      "sector": "Sector",
      "talq_gateway": "TALQ gateway",
      "user": "User"
    }
  },
  "export": {
    "error": "A failure occurred during the CSV file generation",
    "label": "Export",
    "tooltip": "Select rows to be able to export them to CSV format"
  },
  "eventType": {
    "label": "Event type",
    "value": {
      "cyber": "Cyber",
      "device": "Device",
      "device_fleet": "Device fleet",
      "system": "System"
    }
  },
  "level": {
    "label": "Info. level",
    "value": {
      "info": "Information",
      "warning": "Warning",
      "error": "Error",
      "critical": "Critical"
    }
  },
  "timestamp": {
    "label": "Timestamp"
  },
  "filters": {
    "actions": {
      "placeholder": "Search for Actions",
      "empty": "No actions found",
      "actionFound": "No actions found | {count} action found | {count} actions found"
    },
    "applications": {
      "declination": {
        "empty": "No application found"
      },
      "label": "Application",
      "placeholder": "Search for applications",
      "type": {
        "empty": "No type"
      }
    },
    "clear": {
      "label": "Delete the filters"
    },
    "componentId": {
      "label": "Component Id",
      "value": {
        "all": "All"
      }
    },
    "dropdown": {
      "applyAsAFilter": "Apply as a filter",
      "button": {
        "label": "Filters",
        "title": "Display the filters"
      },
      "properties": {
        "device": "Device properties",
        "email_address": "Email properties",
        "gateway": "Gateway properties",
        "group": "Group properties",
        "platform": "Platform properties",
        "profile": "Profile properties",
        "sector": "Sector properties",
        "user": "User properties",
        "pki_config": "PKI properties",
        "interface": "Interface properties"
      }
    },
    "entityClass": {
      "label": "Author or asset class",
      "value": {
        "device": "Device",
        "email_address": "Email address",
        "gateway": "Gateway",
        "group": "Group",
        "platform": "Platform",
        "profile": "Profile",
        "role": "Role",
        "sector": "Sector",
        "user": "User"
      }
    },
    "entity": {
      "label": "Author or asset"
    },
    "sortBy": {
      "label": "Sort",
      "value": {
        "datetime": "Chronolgical"
      }
    },
    "sortDirection": {
      "label": "Ordre",
      "value": {
        "asc": "Acending",
        "desc": "Descending"
      }
    },
    "startDate": {
      "label": "Start Date"
    },
    "status": {
      "label": "Error"
    },
    "timestamp": {
      "formatter": "YYYY-MM-DD",
      "periodSeparator": "to",
      "placeholder": "Select a period"
    },
    "users": {
      "placeholder": "Search for Users"
    },
    "devices": {
      "model": {
        "empty": "No model"
      },
      "type": {
        "empty": "No type"
      }
    },
    "actionTypes": {
      "placeholder": "Search for action types",
      "empty": "No action types found",
      "actionTypesFound": "No action types found | {count} action type found | {count} action types found"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "YYYY-MM-DD hh:mm:ss a"
      },
      "label": {
        "label": "Label"
      }
    },
    "empty": "No log found",
    "unknown": "unknown"
  },
  "origin": {
    "label": "Origin",
    "values": {
      "mobileApplication": "Mobile application",
      "device": "Device",
      "thirdPartyApplication": "Third-party application",
      "lxConnect": "LX CONNECT"
    }
  }
}
